import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { navigate } from '@gatsbyjs/reach-router';

import { getLanguagePrefix } from '@helpers';
import { setLoginRedirectRoute } from '@store/appStateSlice';

const PrivateRoute = ({ component: Component, location, ...rest }) => {
  const { isLoggedIn, prefixLanguage } = useSelector(state => state.appState);
  const dispatch = useDispatch();

  if (
    !isLoggedIn &&
    location.pathname !== `${getLanguagePrefix(prefixLanguage)}/commerce/login/`
  ) {
    if (
      location.pathname !==
      `${getLanguagePrefix(prefixLanguage)}/commerce/logout/`
    ) {
      dispatch(setLoginRedirectRoute(location.pathname));
    }

    navigate(`${getLanguagePrefix(prefixLanguage)}/commerce/login/`, {
      replace: true,
    });
    return null;
  }

  return <Component location={location} {...rest} />;
};

export default PrivateRoute;
